import { createSlice, PayloadAction, createSelector } from 'redux-starter-kit';
import { Resources, Mutations } from '@erecruit/types';

import { selectAppState } from '../../../App/state/selectors';
import { shiftSearchActionBase } from './constants';
import { CancelShiftData } from '../types';

export interface ShiftSearchPayload {
  data: Resources.ShiftSearch[];
  totalCount: number;
}

export interface ShiftSearchState extends ShiftSearchPayload {
  isLoading: boolean;
  error?: string;
  cancelingShift: boolean;
  exporting: boolean;
}

const initialState: ShiftSearchState = {
  isLoading: false,
  data: [],
  totalCount: 0,
  cancelingShift: false,
  exporting: false,
};

const ShiftSearchSlice = createSlice({
  slice: shiftSearchActionBase,
  initialState: initialState,
  reducers: {
    exportShifts(
      state,
      // eslint-disable-next-line
      action: PayloadAction<
        Pick<Mutations.ExportShiftSearchParams, 'columns'> & {
          params: Mutations.ExportShiftSearchParams['shiftSearchParams'];
        }
      >,
    ) {
      state.exporting = true;
    },
    // eslint-disable-next-line
    exportShiftsSuccess(state, action: PayloadAction) {
      state.exporting = false;
    },
    exportShiftsFail(state, action: PayloadAction<string>) {
      state.error = action.payload;
      state.exporting = false;
    },
    searchShifts(
      state,
      // eslint-disable-next-line
      action: PayloadAction<Resources.ShiftSearchParams>,
    ) {
      state.isLoading = true;
    },
    searchShiftsSuccess(state, action: PayloadAction<ShiftSearchPayload>) {
      const { data, totalCount } = action.payload;
      state.data = data;
      state.totalCount = totalCount;
      state.isLoading = false;
    },
    searchShiftsError(state, action: PayloadAction<string>) {
      state.error = action.payload;
    },
    cancelShift(
      state,
      // eslint-disable-next-line
      action: PayloadAction<CancelShiftData>,
    ) {
      state.cancelingShift = true;
    },
    // eslint-disable-next-line
    cancelShiftSuccess(state, action: PayloadAction<ShiftSearchPayload>) {
      state.cancelingShift = false;
    },
    cancelShiftError(state, action: PayloadAction<string>) {
      state.cancelingShift = false;
      state.error = action.payload;
    },
  },
});

const {
  actions,
  reducer,
  selectors: { getShiftSearch },
} = ShiftSearchSlice;

export const {
  searchShifts,
  searchShiftsSuccess,
  searchShiftsError,
  cancelShift,
  cancelShiftSuccess,
  cancelShiftError,
  exportShiftsSuccess,
  exportShiftsFail,
  exportShifts,
} = actions;
export const selectors = {
  selectShiftSearchState: createSelector([selectAppState], getShiftSearch),
};
export default reducer;
